import styled from "@emotion/styled";
import Button from "@mui/material/Button";
import { COLOR_DARK_RED } from "shared/theme/colors";

export const StyledIconButton = styled(Button)`
  display: flex;
  padding: 0;
  margin-top: 16px;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  text-transform: none;
  color: ${COLOR_DARK_RED};
`;
